/*
 * The switch on the add-on line above the cart totals. On adds the product, off
 * takes it back out, and the drawer re-renders from the response either way.
 *
 * There is no state to keep in sync: the checkbox is checked by Liquid when the
 * line is in the cart, and every change replaces this element with a freshly
 * rendered one. That also means nothing here may touch `this` after the render
 * lands — by then this element has been detached.
 */
if (!customElements.get('cart-gift-toggle')) {
  customElements.define(
    'cart-gift-toggle',
    class CartGiftToggle extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.checkbox.addEventListener('change', this.onChange.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onChange() {
        const adding = this.checkbox.checked;

        // Off with no line to remove would post a change for key "", which the
        // cart answers with the whole cart unchanged. Nothing to do.
        if (!adding && !this.dataset.lineKey) return;

        this.checkbox.disabled = true;
        this.classList.add('cart-gift--busy');

        // Read while the elements are still in the DOM — renderContents swaps
        // them out, and getSectionsToRender reaches for ids as it runs.
        const cart = this.cart;
        const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
        const body = adding
          ? { items: [{ id: this.dataset.variantId, quantity: 1 }] }
          : { id: this.dataset.lineKey, quantity: 0 };

        fetch(adding ? routes.cart_add_url : routes.cart_change_url, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({ ...body, sections, sections_url: window.location.pathname }),
        })
          .then((response) => response.json())
          .then((state) => {
            // The cart answers a refusal with 200 and a status in the body, so
            // response.ok says nothing here.
            if (state.status) throw new Error(state.description || state.message);
            if (!cart) return;

            cart.renderContents(state);

            // change.js returns the whole cart and so can say whether anything
            // is left; add.js returns the line it just added, and after an add
            // the cart is never empty.
            if (typeof state.item_count === 'number') {
              cart.classList.toggle('is-empty', state.item_count === 0);
            } else {
              cart.classList.remove('is-empty');
            }
          })
          .catch((error) => {
            console.error(error);

            // Put the switch back where the shopper found it: the cart did not
            // change, so neither should what it says.
            this.checkbox.checked = !adding;
            this.checkbox.disabled = false;
            this.classList.remove('cart-gift--busy');
          });
      }
    }
  );
}
